import { Enum } from "enumify"

class PollContainerType extends Enum {}

PollContainerType.initEnum(["POLL", "WRONGANSWER", "ANSWER", "WHATELSE"])

export default PollContainerType